<script setup>
import useStore from '@/composables/store.js';
import setOrigin from '@/composables/set-origin.js';

const store = useStore();

defineProps({
    size: {
        default: 'normal',
        type: String,
    },
    color: {
        default: 'white',
        type: String,
    },
});

const { goback } = window.CRAFT_LABELS;
const site = store.site.value;
</script>

<template>
    <router-link
        :to="{name:site.language+'.home'}"
        :data-cursor="'circle-'+color"
        data-cursor-adjust-width="true"
        data-cursor-adjust-height="true"
        class="btn-gradient inline-flex items-center rounded-full py-[0.3rem] pl-[0.3rem] pr-4 ring-current"
        v-on:mouseenter="setOrigin($event, 0)"

        v-on:mouseleave="setOrigin($event, 0)"
    >
        <svg
            :class="{
                'h-auto w-12': size == 'small'
            }"
            class="pointer-events-none relative z-10 transition"
            width="98"
            height="98"
            viewBox="0 0 98 98"
            version="1.1"
            overflow="visible"
            xmlns="http://www.w3.org/2000/svg"
            xmlns:xlink="http://www.w3.org/1999/xlink"
        >
            <g
                stroke="currentColor"
                class="transition"
                stroke-width="2"
            >
                <circle
                    id="Oval"
                    cx="49"
                    cy="49"
                    r="49"
                    fill="none"
                />
                <path
                    id="Path"
                    d="M34,43.5 C38.2957671,47.7957671 45,54.5 45,54.5 L56,43.5"
                    stroke-linecap="round"
                    fill="none"
                    transform="translate(45, 49) rotate(-270) translate(-45, -49)"
                />
            </g>
        </svg>
        <span class="btn-text ml-2.5 text-base xl:text-lg">
            {{ goback }}
        </span>
        <span class="background-fill" aria-hidden />
    </router-link>
</template>
